(function ( $ ) {
	document.addEventListener( 'DOMContentLoaded', function () {

		Fancybox.bind('[data-fancybox]', {
			// Your custom options
		});

		// Блокируем автоматическую обработку попапа СМС через Fancybox
		// Добавляем обработчик, который предотвращает открытие попапов при клике внутри #sms-popup
		document.addEventListener('click', function(e) {
			const smsPopup = document.getElementById('sms-popup');
			if (smsPopup && smsPopup.contains(e.target)) {
				const target = e.target;

				// Разрешаем клики ТОЛЬКО на интерактивные элементы формы
				const isFormInteractiveElement = target.tagName === 'BUTTON' ||
				                               target.tagName === 'INPUT' ||
				                               target.tagName === 'TEXTAREA' ||
				                               target.closest('.form-sms button') ||
				                               target.closest('.form-sms input') ||
				                               target.closest('.btn-resend-code') ||
				                               target.closest('#sms-recaptcha-container');

				// Если это НЕ элемент формы, блокируем ВСЁ
				if (!isFormInteractiveElement) {
					e.stopPropagation();
					e.stopImmediatePropagation();
					e.preventDefault();
					return false;
				}
			}
		}, true); // Используем capture phase, чтобы перехватить до Fancybox

		// Инициализация системы бронирования
		if (typeof initBookingSystem === 'function') {
			initBookingSystem();
		}

		// Маска на телефон
		$( "input[name*=-phone]" ).mask( "+9 (999) 999-9999" );

		// анимация лейблов форм
		if ( isExist( '.form-wrapper' ) ) {
			const forms = document.querySelectorAll( '.form-wrapper' );

			forms.forEach( ( form ) => {
				const inputs = form.querySelectorAll( 'input, textarea' );
				inputs.forEach( ( input ) => {
					input.onfocus = function ( e ) {
						const label = input.closest( 'label' );
						label.classList.add( 'active' )
					}
					input.onblur = function ( e ) {
						const label = input.closest( 'label' );
						label.classList.remove( 'active' )
					}
				} );
			} );
		}

		// Оборачиваем изображения в ссылки
		if (isExist('.container-text .wp-block-image')) {
			let wpImage = document.querySelectorAll('.container-text .wp-block-image');

			wpImage.forEach((image) => {
				const imgElement = image.querySelector('img'),
					figcaptionElement = image.querySelector('figcaption'),
					src = imgElement.src;

				if (!image.parentElement.classList.contains('wp-block-gallery')) {

					let org_html = image.innerHTML;

					if (imgElement && figcaptionElement) {
						org_html = org_html.replace(/<figcaption\b[^>]*>.*?<\/figcaption>/i, '');
						image.innerHTML = `<a href="${src}" data-fancybox>${org_html}</a>${figcaptionElement.outerHTML}`;
					} else {
						image.innerHTML = `<a href="${src}" data-fancybox>${org_html}</a>`;
					}
				}
			});
		}

		// Галереи на дефолтной странице
		if (isExist('.container-text .wp-block-gallery')) {
			let wpGalleries = document.querySelectorAll('.container-text .wp-block-gallery');

			wpGalleries.forEach((gallery, index) => {
				let wpImages = gallery.querySelectorAll('.wp-block-image');
				let minHeight = Number.MAX_SAFE_INTEGER;

				wpImages.forEach((image) => {
					const imgElement = image.querySelector('img'),
						figcaptionElement = image.querySelector('figcaption'),
						src = imgElement.src;

					let org_html = image.innerHTML;

					if (imgElement && figcaptionElement) {
						org_html = org_html.replace(/<figcaption\b[^>]*>.*?<\/figcaption>/i, '');
						image.innerHTML = `<a href="${src}" data-fancybox="gallery-${index}">${org_html}</a>${figcaptionElement.outerHTML}`;
					} else {
						image.innerHTML = `<a href="${src}" data-fancybox="gallery-${index}">${org_html}</a>`;
					}

					// Добавление проверки изображений на высоту и присваивания всем минимальной высоты
					const height = image.offsetHeight;

					if (height < minHeight) {
						minHeight = height;
					}
				});

				wpImages.forEach((img) => {
					img.style.height = `${minHeight}px`;
				});
			});
		}


		// валидация форм
		let forms = document.querySelectorAll('.wpcf7');

		for (let form of forms) {
			if(form.dataset.wpcf7Id=='415'){
				form.addEventListener('wpcf7mailsent', function () {
					Fancybox.close();
					Fancybox.show([{src: '#success-popup-sub', type: "inline"}]);
				});
			}else{
				form.addEventListener('wpcf7mailsent', function () {
					Fancybox.close();
					Fancybox.show([{src: '#success-popup', type: "inline"}]);
				});
			}

			form.addEventListener('wpcf7mailfailed', function () {
				Fancybox.close();
				Fancybox.show([{src: '#failed-popup', type: "inline"}]);
			});
		}

		sal({
			threshold: .1,
		});

		if(isExist('.hamburger-button')){
			document.querySelector('.hamburger-button').addEventListener('click', (e)=>{
				if(document.querySelector('header').classList.contains('active')){
					closeMenu(document.querySelector('header'));
				}else{
					openMenu(document.querySelector('header'));
				}
			})
		}
		if(isExist('.search-close')){
			document.querySelector('.search-close').addEventListener('click', (e)=>{
				if(document.querySelector('header').classList.contains('search-active')){
					closeSearch(document.querySelector('header'));
					document.querySelector('.search-results').classList.add('empty');
					document.querySelector('.search .search-control .search-bar .search-input #header_search').value = '';
					document.querySelector('.search .search-control .search-bar .search-input .search-clear').style.display = "none";
				}else{
					openSearch(document.querySelector('header'));
				}
			})
		}
		if(isExist('.mobile-filters__trigger')){
			document.querySelector('.mobile-filters__trigger').addEventListener('click', (e)=>{
				if(document.body.classList.contains('mobileFilters-active')){
					closeMobileFilters(document.querySelector('.catalog__mobile-filters'));
				}else{
					openMobileFilters(document.querySelector('.catalog__mobile-filters'));
				}
			})
		}
		if(isExist('.mobile-filter-trigger')){
			document.querySelector('.mobile-filter-trigger').addEventListener('click', (e)=>{
				if(document.body.classList.contains('mobileFilters-active')){
					closeMobileFilters(document.querySelector('.catalog__mobile-filters'));
				}else{
					openMobileFilters(document.querySelector('.catalog__mobile-filters'));
				}
			})
		}
		if(isExist('.tool__search')){
			document.querySelector('.tool__search').addEventListener('click', (e)=>{
				if(document.querySelector('header').classList.contains('search-active')){
					closeSearch(document.querySelector('header'));
				}else{
					openSearch(document.querySelector('header'));
				}
			})
		}
		if(isExist('header')){
			// Функция для обновления состояния шапки
			function updateHeaderFixed() {
				const header = document.querySelector('header');
				if (header) {
					if (window.scrollY > 0) {
						header.classList.add('fixed');
					} else {
						header.classList.remove('fixed');
					}
				}
			}

			// Обновляем состояние при загрузке страницы
			document.addEventListener('DOMContentLoaded', () => {
				// Небольшая задержка для корректного определения scrollY
				setTimeout(updateHeaderFixed, 10);
			});

			// Обновляем состояние при прокрутке
			document.addEventListener('scroll', updateHeaderFixed);

			// Дополнительная проверка после полной загрузки страницы
			window.addEventListener('load', () => {
				setTimeout(updateHeaderFixed, 10);
			});

			// Проверяем состояние при изменении размера окна
			window.addEventListener('resize', () => {
				setTimeout(updateHeaderFixed, 10);
			});

			// Проверяем состояние при изменении видимости страницы
			document.addEventListener('visibilitychange', () => {
				if (!document.hidden) {
					setTimeout(updateHeaderFixed, 10);
				}
			});
		}

		if(isExist('.hero__background')){
			document.querySelector('.hero__background').addEventListener('mouseover', (e)=>{
				document.querySelector('.main_bc').classList.remove('hidden');
				document.querySelectorAll('.menu__item-bc').forEach(itemBC => {
					itemBC.classList.remove('active');
				})
			})
		}

		if(isExist('.hero__menu .menu__item')){
			document.querySelectorAll('.hero__menu .menu__item').forEach(item => {
				item.addEventListener('mouseover', (e)=>{
					document.querySelector('.main_bc').classList.add('hidden');
					let targetId = e.target.dataset.itemid;
					document.querySelectorAll('.menu__item-bc').forEach(itemBC => {
						if(itemBC.dataset.itemid===targetId){
							itemBC.classList.add('active');
						}else{
							itemBC.classList.remove('active');
						}
					})
				})
			})
		}
		// Скрипт для дублирования контента в бегущей строке
        if (isExist('.marquee') && isExist('.marquee__content')) {
            document.querySelectorAll(".marquee__content").forEach((marqueeContent) => {
                const cloneCount = 4; // Количество дублирований
                let contentHTML = marqueeContent.innerHTML;

                for (let i = 0; i < cloneCount; i++) {
                    marqueeContent.innerHTML += contentHTML;
                }
            });
        }
		if(isExist('.look-map-point')){
			document.addEventListener('click', (e)=>{
				if(e.target.closest('.look-map-point')){
					e.preventDefault();
					const clickedPoint = e.target.closest('.look-map-point');
					const lookItem = clickedPoint.closest('.look-item');

					if(clickedPoint.classList.contains('active')&&!e.target.closest('.look-map-point-desc')){
						clickedPoint.classList.remove('active');
						lookItem.classList.remove('active');
					}else{
						document.querySelectorAll('.look-map-point').forEach(point=>{
							point.classList.remove('active');
						})
						document.querySelectorAll('.look-item').forEach(item=>{
							item.classList.remove('active');
						})
						clickedPoint.classList.add('active');
						lookItem.classList.add('active');
					}
				}else{
					document.querySelectorAll('.look-map-point').forEach(point=>{
						point.classList.remove('active');
					})
					document.querySelectorAll('.look-item').forEach(item=>{
						item.classList.remove('active');
					})
				}
			})
		}

		// Инициализируем ленивую загрузку видео
		if (typeof initLazyVideoLoading === 'function') {
			initLazyVideoLoading();
		}
		if(isExist('.forceLink')){
			document.querySelectorAll('.forceLink').forEach(link=>{
				link.addEventListener('click', (e)=>{
					forceChangeLocation(e.target.dataset.href);
				})
			})
		}
		// Инициализируем кнопки избранного (только для существующих элементов)
		if(isExist('.tool-favorite')){
			document.querySelectorAll('.tool-favorite').forEach(fav=>{
				if(isInFavorites(fav.dataset.id, fav.dataset.type)){
					fav.classList.add('isInFavorites');
				}
			})
		}

		// Обработчик кнопок избранного перенесен в main-function.js для избежания дублирования

		// Инициализируем систему избранных постов
		if (typeof setupFavoritesSystem === 'function') {
			setupFavoritesSystem();
		}

		// Инициализируем страницу избранного
		if (isExist('.favorites-grid') && typeof initFavoritesPage === 'function') {
			initFavoritesPage();
		}

		// Инициализируем большие карточки
		if (typeof initBigItemCards === 'function') {
			initBigItemCards();
		}

		if (typeof initCategoryFiltering === 'function') {
			initCategoryFiltering();
		} else {
			console.log('❌ initCategoryFiltering недоступна, ждем загрузки main-function.js...');
			// Ждем загрузки main-function.js
			let attempts = 0;
			const maxAttempts = 50; // 5 секунд максимум
			const checkInterval = setInterval(() => {
				attempts++;
				if (typeof initCategoryFiltering === 'function') {
					console.log('✅ initCategoryFiltering стала доступна, вызываем...');
					clearInterval(checkInterval);
					initCategoryFiltering();
				} else if (attempts >= maxAttempts) {
					console.log('❌ initCategoryFiltering так и не стала доступна, используем альтернативную инициализацию');
					clearInterval(checkInterval);
					// Если initCategoryFiltering недоступен, инициализируем URL параметры напрямую
					if (isExist('.catalog-list') && isExist('.products-grid')) {
						// Для страниц товаров используем initProductUrlParameters
						if (typeof initProductUrlParameters === 'function') {
							initProductUrlParameters();
						}
					} else if (isExist('.catalog-list')) {
						// Для страниц образов используем initUrlParameters
						console.log('🎯 Страница образов, используем initUrlParameters');
						if (typeof initUrlParameters === 'function') {
							console.log('✅ initUrlParameters доступна, вызываем...');
							initUrlParameters();
						} else {
							console.log('❌ initUrlParameters недоступна');
						}
					} else {
						// Для других страниц используем initUrlParameters
						if (typeof initUrlParameters === 'function') {
							initUrlParameters();
						}
					}
				}
			}, 100);
		}

		// Инициализируем слайдер stylists-slider__main
		if (isExist('.stylists-slider__main')) {
			initSliderMain();
		}

		// Инициализируем кастомные селекты
		if (typeof initCustomSelects === 'function') {
			initCustomSelects();
		}

		// Инициализируем кнопку "Наверх"
		initBackToTop();

		// Инициализируем мобильный фильтр для образов
		if (isExist('.archive-look .catalog__mobile-filters')) {
			initLookMobileFilters();
		}
	} );
	document.addEventListener('DOMContentLoaded', function() {
		// Инициализируем кастомные селекты при загрузке DOM
		if (typeof initCustomSelects === 'function') {
			initCustomSelects();
		}

		// Обработчик для кнопки копирования ссылки
		const copyLinkButtons = document.querySelectorAll('.copy-link-btn');

		copyLinkButtons.forEach(function(button) {
			button.addEventListener('click', function(e) {
				e.preventDefault();

				const urlToCopy = this.getAttribute('data-url');

				// Пытаемся скопировать в буфер обмена
				if (navigator.clipboard && window.isSecureContext) {
					// Современный способ для HTTPS
					navigator.clipboard.writeText(urlToCopy).then(function() {
						showCopyNotification('Ссылка скопирована в буфер обмена!');
					}).catch(function(err) {
						console.error('Ошибка копирования: ', err);
						fallbackCopyTextToClipboard(urlToCopy);
					});
				} else {
					// Fallback для старых браузеров или HTTP
					fallbackCopyTextToClipboard(urlToCopy);
				}
			});
		});

		// Fallback функция для копирования
		function fallbackCopyTextToClipboard(text) {
			const textArea = document.createElement("textarea");
			textArea.value = text;

			// Избегаем прокрутки в мобильных браузерах
			textArea.style.top = "0";
			textArea.style.left = "0";
			textArea.style.position = "fixed";
			textArea.style.opacity = "0";

			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();

			try {
				const successful = document.execCommand('copy');
				if (successful) {
					showCopyNotification('Ссылка скопирована в буфер обмена!');
				} else {
					showCopyNotification('Не удалось скопировать ссылку', 'error');
				}
			} catch (err) {
				console.error('Fallback: Ошибка копирования: ', err);
				showCopyNotification('Не удалось скопировать ссылку', 'error');
			}

			document.body.removeChild(textArea);
		}

		// Функция показа уведомления через Fancybox
		function showCopyNotification(message, type = 'success') {
			// Создаем HTML для уведомления
			const notificationHtml = `
				<div class="copy-notification ${type}">
					<div class="notification-content">
						<div class="notification-icon">
							${type === 'success' ?
								'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor"/></svg>' :
								'<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" fill="currentColor"/></svg>'
							}
						</div>
						<div class="notification-text">${message}</div>
					</div>
				</div>
			`;

			// Проверяем доступность jQuery и Fancybox
			if (typeof $ !== 'undefined' && typeof $.fancybox !== 'undefined') {
				$.fancybox.open({
					src: notificationHtml,
					type: 'html',
					opts: {
						closeClickOutside: false,
						closeBtn: false,
						toolbar: false,
						smallBtn: false,
						buttons: [],
						animationEffect: 'fade',
						animationDuration: 300,
						afterShow: function() {
							// Автоматически закрываем через 2 секунды
							setTimeout(function() {
								$.fancybox.close();
							}, 2000);
						}
					}
				});
			} else {
				// Fallback: создаем собственное уведомление
				showCustomNotification(message, type);
			}
		}

		// Функция для показа собственного уведомления
		function showCustomNotification(message, type = 'success') {
			// Создаем элемент уведомления
			const notification = document.createElement('div');
			notification.className = `custom-copy-notification ${type}`;
			notification.innerHTML = `
				<div class="notification-content">
					<div class="notification-text">${message}</div>
				</div>
			`;

			// Добавляем стили для позиционирования
			notification.style.cssText = `
				position: fixed;
				top: 20px;
				right: 20px;
				z-index: 9999;
				padding: 15px 20px;
				border-radius: 8px;
				box-shadow: 0 4px 12px rgba(0,0,0,0.15);
				background: white;
				border-left: 4px solid ${type === 'success' ? '#000' : '#000'};
				color: ${type === 'success' ? '#000' : '#000'};
				font-family: "TildaSans",-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
				font-size: 14px;
				font-weight: 500;
				max-width: 300px;
				opacity: 0;
				transform: translateX(100%);
				transition: all 0.3s ease;
			`;

			// Добавляем в DOM
			document.body.appendChild(notification);

			// Анимация появления
			setTimeout(() => {
				notification.style.opacity = '1';
				notification.style.transform = 'translateX(0)';
			}, 10);

			// Автоматически удаляем через 3 секунды
			setTimeout(() => {
				notification.style.opacity = '0';
				notification.style.transform = 'translateX(100%)';
				setTimeout(() => {
					if (notification.parentNode) {
						notification.parentNode.removeChild(notification);
					}
				}, 300);
			}, 3000);
		}
	});
	document.addEventListener('DOMContentLoaded', function() {
		// Инициализация слайдера товаров из образа
		const productsSlider = document.querySelector('.products-slider');
		if (productsSlider) {
			const productsSwiper = new Swiper('.products-slider', {
				slidesPerView: 4,
				spaceBetween: 6,
				loop: false,
				navigation: {
					nextEl: '.products-next',
					prevEl: '.products-prev',
				},
				breakpoints: {
					320: {
						slidesPerView: 'auto',
						spaceBetween: 3,
					},
					768: {
						slidesPerView: 'auto',
						spaceBetween: 3,
					},
					1200: {
						slidesPerView: 4,
						spaceBetween: 6,
					}
				}
			});
		}

		// Инициализация слайдера похожих образов
		const similarLooksSlider = document.querySelector('.similar-looks-slider');
		if (similarLooksSlider) {
			const similarLooksSwiper = new Swiper('.similar-looks-slider', {
				slidesPerView: 4,
				spaceBetween: 6,
				loop: false,
				navigation: {
					nextEl: '.similar-looks-next',
					prevEl: '.similar-looks-prev',
				},
				breakpoints: {
					320: {
						slidesPerView: 'auto',
						spaceBetween: 3,
					},
					768: {
						slidesPerView: 'auto',
						spaceBetween: 3,
					},
					1200: {
						slidesPerView: 4,
						spaceBetween: 6,
					}
				}
			});
		}

		// Инициализация слайдера образов стилиста
		const stylistLooksSlider = document.querySelector('.stylist-looks-slider');
		if (stylistLooksSlider) {
			const stylistLooksSwiper = new Swiper('.stylist-looks-slider', {
				slidesPerView: 4,
				spaceBetween: 6,
				loop: false,
				navigation: {
					nextEl: '.stylist-looks-next',
					prevEl: '.stylist-looks-prev',
				},
			});
		}

		// Инициализация слайдера образов стилиста
		const stylistLooksAllSlider = document.querySelector('.stylist-looks-grid');
		if (stylistLooksAllSlider&&window.outerWidth<=768) {
			const stylistLooksAllSwiper = new Swiper('.stylist-looks-grid', {
				slidesPerView: 2,
				spaceBetween: 6,
				loop: false,
				navigation: {
					nextEl: '.stylist-looks-next',
					prevEl: '.stylist-looks-prev',
				},
				breakpoints: {
					320: {
						slidesPerView: 'auto',
						spaceBetween: 3,
					},
					768: {
						slidesPerView: 'auto',
						spaceBetween: 3,
					},
				}
			});
		}
		if(isExist('.accordion-container')){
			let accordions = document.querySelectorAll('.accordion-container');
			accordions.forEach(accordion => {
				accordion.querySelector('.accordion-trigger').addEventListener('click', (e) => {
					e.preventDefault();
					if(!e.target.closest('.accordion-container').classList.contains('active')){
						accordions.forEach(accordionDiactivate => {
							accordionDiactivate.classList.remove('active');
						})
						e.target.closest('.accordion-container').classList.add('active');
					}else{
						accordions.forEach(accordionDiactivate => {
							accordionDiactivate.classList.remove('active');
						})
					}
				})
			});
		}
		if(isExist('.shopping')){
			// Вызываем функцию getStylist и выводим результат в консоль
			let shoppingBlock = document.querySelector('.shopping'),
				shoppingContent = shoppingBlock.querySelector('.shopping__left-part'),
				shoppingForm = shoppingBlock.querySelector('.shopping-form');

			// Показываем прелоадер перед запросом
			if (typeof showLoadingState === 'function') {
				showLoadingState();
			}

			getStylist().then(result => {

				if(result && result.success){
					// Проверяем структуру данных
					let stylistsData = null;

					if (result.data && result.data.results) {
						stylistsData = result.data.results;
					} else if (result.results) {
						stylistsData = result.results;
					} else if (Array.isArray(result)) {
						stylistsData = result;
					}

					if (stylistsData && Array.isArray(stylistsData)) {

						// Сохраняем данные в глобальную переменную
						window.stylistsData = { results: stylistsData };

						// Скрываем прелоадер
						if (typeof hideLoadingState === 'function') {
							hideLoadingState();
						}

						// Заполняем селект стилистов данными из API
						if (typeof populateStylistSelect === 'function') {
							// Автоматически выбираем стилиста для single-stylist страницы после загрузки данных
							const bookingForm = document.querySelector('.shopping-form[data-initial-stylist-id]');
							const initialStylistId = bookingForm ? bookingForm.getAttribute('data-initial-stylist-id') : null;

							// Функция для выбора стилиста
							const selectInitialStylist = () => {
								if (!bookingForm || !initialStylistId || initialStylistId === '' || initialStylistId === '0') {
									return;
								}

								const stylistSelect = bookingForm.querySelector('[data-select="stylist"]');
								if (!stylistSelect) {
									console.error('Селект стилистов не найден в форме');
									return;
								}

								console.log('Пытаемся выбрать стилиста с ID:', initialStylistId);

								// Преобразуем ID в строку для сравнения
								const stylistIdStr = String(initialStylistId);

								// Проверяем, что опция с нужным ID существует (пробуем разные варианты сравнения)
								let option = stylistSelect.querySelector(`.custom-select__option[data-value="${stylistIdStr}"]`);

								// Если не нашли, пробуем найти по числовому значению
								if (!option) {
									const allOptions = stylistSelect.querySelectorAll('.custom-select__option');
									console.log('Ищем среди', allOptions.length, 'опций');
									allOptions.forEach(opt => {
										const optValue = opt.getAttribute('data-value');
										if (optValue == initialStylistId) { // Нестрогое сравнение
											option = opt;
											console.log('Найдена опция с value:', optValue, 'текст:', opt.textContent);
										}
									});
								}

								if (option) {
									console.log('Опция найдена, выбираем стилиста');

									// Используем прямое кликание по опции вместо setCustomSelectValue
									// чтобы избежать конфликта с функцией из main-function.js
									const hiddenInput = stylistSelect.querySelector('input[type="hidden"][name="shopping_stylist"]');
									const valueSpan = stylistSelect.querySelector('.custom-select__value');

									if (hiddenInput) {
										hiddenInput.value = stylistIdStr;
									}
									if (valueSpan) {
										valueSpan.textContent = option.textContent;
									}

									// Закрываем селект, если он открыт
									stylistSelect.classList.remove('active');

									// Блокируем селект на страницах single-stylist, чтобы нельзя было изменить выбор
									stylistSelect.classList.add('disabled');
									stylistSelect.style.pointerEvents = 'none';
									stylistSelect.style.opacity = '0.6';
									stylistSelect.style.cursor = 'not-allowed';

									// Также блокируем триггер
									const trigger = stylistSelect.querySelector('.custom-select__trigger');
									if (trigger) {
										trigger.style.pointerEvents = 'none';
										trigger.style.cursor = 'not-allowed';
									}

									console.log('✅ Автоматически выбран стилист с ID:', initialStylistId, 'имя:', option.textContent);
									console.log('Селект стилиста заблокирован для изменения');

									// Триггерим событие change для обновления календаря и других зависимостей
									if (hiddenInput) {
										// Небольшая задержка перед триггером события, чтобы все обработчики успели инициализироваться
										setTimeout(() => {
											hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
										}, 100);
									}
								} else {
									console.warn('Опция со стилистом ID', initialStylistId, 'не найдена в селекте');
									// Выводим все доступные опции для отладки
									const allOptions = stylistSelect.querySelectorAll('.custom-select__option');
									console.log('Доступные опции:', Array.from(allOptions).map(opt => ({
										value: opt.getAttribute('data-value'),
										text: opt.textContent
									})));
								}
							};

							if (bookingForm && initialStylistId && initialStylistId !== '' && initialStylistId !== '0') {
								console.log('Найден initial-stylist-id:', initialStylistId);
								const stylistSelect = bookingForm.querySelector('[data-select="stylist"]');

								if (stylistSelect) {
									console.log('Селект стилистов найден, подписываемся на событие stylistsPopulated');

									// Подписываемся на событие заполнения селекта ДО вызова populateStylistSelect
									let handled = false;
									const handleStylistsPopulated = (e) => {
										if (handled) return;
										handled = true;
										console.log('Событие stylistsPopulated получено', e.target === stylistSelect ? 'на элементе' : 'на document');
										setTimeout(selectInitialStylist, 100);
										stylistSelect.removeEventListener('stylistsPopulated', handleStylistsPopulated);
										document.removeEventListener('stylistsPopulated', handleStylistsPopulated);
									};

									// Подписываемся и на элемент, и на document
									stylistSelect.addEventListener('stylistsPopulated', handleStylistsPopulated);
									document.addEventListener('stylistsPopulated', handleStylistsPopulated);
								} else {
									console.error('Селект стилистов не найден в форме');
								}
							}

							// Заполняем селект (это вызовет событие stylistsPopulated)
							populateStylistSelect(stylistsData);
						} else {
							console.error('Функция populateStylistSelect не найдена');
						}

						// Инициализируем обработчики событий для формы
						if (typeof initShoppingFormHandlers === 'function') {
							initShoppingFormHandlers();
						}
					} else {

						// Скрываем прелоадер и показываем ошибку
						if (typeof hideLoadingState === 'function') {
							hideLoadingState();
						}
						if (typeof showErrorState === 'function') {
							showErrorState('Данные стилистов не найдены в ожидаемом формате');
						}
					}
				} else {

					// Скрываем прелоадер и показываем ошибку
					if (typeof hideLoadingState === 'function') {
						hideLoadingState();
					}
					if (typeof showErrorState === 'function') {
						showErrorState('Ошибка получения данных стилистов: ' + (result.error || 'Неизвестная ошибка'));
					}
				}
			}).catch(error => {

				// Скрываем прелоадер и показываем ошибку
				if (typeof hideLoadingState === 'function') {
					hideLoadingState();
				}
				if (typeof showErrorState === 'function') {
					showErrorState('Ошибка при загрузке данных: ' + error.message);
				}
			});
		}

		// Валидация формы бронирования
		if(isExist('.shopping-form')){
			const bookingForm = document.querySelector('.shopping-form');
			window.isFormSubmitted = false; // Флаг для предотвращения повторной отправки
			window.recaptchaWidgetId = null; // ID виджета reCAPTCHA

			// Функция инициализации reCAPTCHA
			function initRecaptcha() {
				const recaptchaContainer = document.getElementById('recaptcha-container');
				if (!recaptchaContainer) {
					return false;
				}

				if (typeof grecaptcha === 'undefined') {
					return false;
				}

				// Если уже инициализирован, не инициализируем повторно
				if (window.recaptchaWidgetId !== null) {
					return true;
				}

				// Проверяем, не инициализирован ли уже виджет в этом контейнере
				if (recaptchaContainer.hasChildNodes()) {
					// Виджет уже отрендерен, получаем его ID
					const widgetId = recaptchaContainer.getAttribute('data-widget-id');
					if (widgetId) {
						window.recaptchaWidgetId = parseInt(widgetId);
						return true;
					}
				}

				try {
					// Получаем sitekey из настроек WordPress
					let sitekey = null;

					// Пытаемся получить ключ из ajax_object (передается через wp_localize_script)
					if (typeof ajax_object !== 'undefined' && ajax_object.recaptcha_site_key) {
						sitekey = ajax_object.recaptcha_site_key;
					}
					// Также проверяем data-атрибут контейнера
					if (!sitekey && recaptchaContainer.dataset.sitekey) {
						sitekey = recaptchaContainer.dataset.sitekey;
					}

					if (!sitekey || sitekey.trim() === '') {

						return false;
					}

					window.recaptchaWidgetId = grecaptcha.render('recaptcha-container', {
						'sitekey': sitekey,
						// Убираем callback, чтобы форма не отправлялась автоматически при прохождении капчи
						// Токен будет получаться только при нажатии кнопки "Отправить"
						'error-callback': function(error) {
							console.error('Ошибка reCAPTCHA:', error);
							if (error && error.error) {
								if (error.error === 'invalid-site-key' || error.error === 'invalid-input-response') {
									console.error('Ошибка: неверный домен ключа. Убедитесь, что ключ настроен для домена ' + window.location.hostname + ' в Google reCAPTCHA Console.');
									alert('Ошибка настройки reCAPTCHA: неверный домен ключа. Обратитесь к администратору.');
								}
							}
						}
					});

					return true;
				} catch (error) {

					return false;
				}
			}

			// Функция ожидания появления контейнера и инициализации
			function waitForContainerAndInit() {
				const recaptchaContainer = document.getElementById('recaptcha-container');
				if (recaptchaContainer && typeof grecaptcha !== 'undefined') {
					const result = initRecaptcha();

					return result;
				}
				return false;
			}

			// Инициализация reCAPTCHA после загрузки
			function startRecaptchaInit() {
				// Сначала ждем загрузки grecaptcha
				if (typeof grecaptcha === 'undefined') {
					if (typeof captchaIsReady !== 'undefined') {
						captchaIsReady.then(() => {
							// Ждем появления контейнера с повторными попытками
							let attempts = 0;
							const maxAttempts = 50; // 5 секунд максимум
							const checkContainer = setInterval(() => {
								attempts++;
								if (waitForContainerAndInit() || attempts >= maxAttempts) {
									clearInterval(checkContainer);
								}
							}, 100);
						}).catch(() => {
							// Если Promise отклонен, пробуем инициализировать напрямую
							setTimeout(() => {
								let attempts = 0;
								const maxAttempts = 50;
								const checkContainer = setInterval(() => {
									attempts++;
									if (waitForContainerAndInit() || attempts >= maxAttempts) {
										clearInterval(checkContainer);
									}
								}, 100);
							}, 500);
						});
					} else {
						// Ждем загрузки grecaptcha
						const checkGrecaptcha = setInterval(() => {
							if (typeof grecaptcha !== 'undefined') {
								clearInterval(checkGrecaptcha);
								// После загрузки ждем контейнер
								let attempts = 0;
								const maxAttempts = 50;
								const checkContainer = setInterval(() => {
									attempts++;
									if (waitForContainerAndInit() || attempts >= maxAttempts) {
										clearInterval(checkContainer);
									}
								}, 100);
							}
						}, 100);

						// Таймаут на случай, если reCAPTCHA не загрузится
						setTimeout(() => {
							clearInterval(checkGrecaptcha);
						}, 10000);
					}
				} else {
					// grecaptcha уже загружен, просто ждем контейнер
					let attempts = 0;
					const maxAttempts = 50;
					const checkContainer = setInterval(() => {
						attempts++;
						if (waitForContainerAndInit() || attempts >= maxAttempts) {
							clearInterval(checkContainer);
						}
					}, 100);
				}
			}

			// Запускаем инициализацию
			startRecaptchaInit();

			// Callback функция для reCAPTCHA v2 формы бронирования стилиста
			// УДАЛЕНО: callback больше не используется, чтобы форма не отправлялась автоматически
			// Токен reCAPTCHA будет получаться только при нажатии кнопки "Отправить"
			// window.onBookingFormRecaptchaSuccess = function(token) { ... };

			// Функция для валидации поля
			function validateField(field, validator, errorMessage) {
				const isValid = validator(field.value);

				// Ищем контейнер .field-block для всех полей
				let fieldContainer = field.closest('.field-block');

				// Если не найден .field-block, ищем другие возможные контейнеры
				if (!fieldContainer) {
					fieldContainer = field.closest('.field') || field.closest('.shopping-form__field-cont') || field.closest('.agreement-cont');
				}

				// Специальная обработка для поля времени (скрытый input в кастомном селекте)
				if (!fieldContainer && field.name === 'shopping_time') {
					// Ищем кастомный селект времени и его контейнер
					const timeSelect = document.querySelector('[data-select="time"]');
					if (timeSelect) {
						fieldContainer = timeSelect.closest('.field-block') || timeSelect.closest('.field');
					}
				}

				// Специальная обработка для поля стилиста (скрытый input в кастомном селекте)
				if (!fieldContainer && field.name === 'shopping_stylist') {
					// Ищем кастомный селект стилиста и его контейнер
					const stylistSelect = document.querySelector('[data-select="stylist"]');
					if (stylistSelect) {
						fieldContainer = stylistSelect.closest('.field-block') || stylistSelect.closest('.field');
					}
				}

				// Если контейнер - это сам input, ищем его родительский контейнер
				if (fieldContainer === field) {
					fieldContainer = field.parentNode;
				}

				// Проверяем, что контейнер найден
				if (!fieldContainer) {
					console.error('Контейнер поля не найден для:', field);
					return isValid;
				}

				// Очищаем предыдущие ошибки для этого поля
				const existingError = fieldContainer.querySelector('div.field-error');
				if (existingError) {
					existingError.remove();
				}
				field.classList.remove('field-error');
				fieldContainer.classList.remove('field-error');

				if (!isValid) {
					// Добавляем класс ошибки
					field.classList.add('field-error');
					fieldContainer.classList.add('field-error');

					// Создаем элемент ошибки
					const errorElement = document.createElement('div');
					errorElement.className = 'field-error field-error-text';
					errorElement.textContent = errorMessage;

					// Добавляем ошибку в конец контейнера поля
					fieldContainer.appendChild(errorElement);

					return false;
				}

				return true;
			}

			// Валидаторы для полей
			const validators = {
				stylist: (value) => value && value.trim() !== '',
				date: (value) => value && value.trim() !== '',
				time: (value) => value && value.trim() !== '',
				name: (value) => value && value.trim().length >= 2,
				lastname: (value) => value && value.trim().length >= 2,
				phone: (value) => {
					const phoneRegex = /^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/;
					return value && phoneRegex.test(value.replace(/\s/g, ''));
				},
				agreement: (value) => {
					// Для чекбокса проверяем свойство checked, а не value
					const agreementField = document.querySelector('input[name="shopping_agreement"]');
					return agreementField ? agreementField.checked : false;
				}
			};

			// Сообщения об ошибках
			const errorMessages = {
				stylist: 'Пожалуйста, выберите стилиста',
				date: 'Пожалуйста, выберите дату',
				time: 'Пожалуйста, выберите время',
				name: 'Имя должно содержать минимум 2 символа',
				lastname: 'Фамилия должна содержать минимум 2 символа',
				phone: 'Введите корректный номер телефона',
				agreement: 'Необходимо согласие на обработку персональных данных'
			};

			// Функция для валидации всей формы
			function validateForm() {
				let isFormValid = true;

				// Валидация стилиста
				const stylistField = document.querySelector('input[name="shopping_stylist"]');
				if (stylistField) {
					isFormValid = validateField(stylistField, validators.stylist, errorMessages.stylist) && isFormValid;
				}

				// Валидация даты
				const dateField = document.querySelector('input[name="shopping_date"]');
				if (dateField) {
					isFormValid = validateField(dateField, validators.date, errorMessages.date) && isFormValid;
				}

				// Валидация времени
				const timeField = document.querySelector('input[name="shopping_time"]');
				if (timeField) {
					isFormValid = validateField(timeField, validators.time, errorMessages.time) && isFormValid;
				}

				// Валидация имени
				const nameField = document.querySelector('input[name="shopping_customer_name"]');
				if (nameField) {
					isFormValid = validateField(nameField, validators.name, errorMessages.name) && isFormValid;
				}

				// Валидация фамилии
				const lastnameField = document.querySelector('input[name="shopping_customer_lastname"]');
				if (lastnameField) {
					isFormValid = validateField(lastnameField, validators.lastname, errorMessages.lastname) && isFormValid;
				}

				// Валидация телефона
				const phoneField = document.querySelector('input[name="shopping_customer_phone"]');
				if (phoneField) {
					isFormValid = validateField(phoneField, validators.phone, errorMessages.phone) && isFormValid;
				}

				// Валидация согласия
				const agreementField = document.querySelector('input[name="shopping_agreement"]');
				if (agreementField) {
					isFormValid = validateField(agreementField, validators.agreement, '') && isFormValid;
				}

				return isFormValid;
			}

			// Добавляем маску для телефона
			const phoneField = document.querySelector('input[name="shopping_customer_phone"]');
			if (phoneField) {
				// Функция для форматирования телефона
				function formatPhone(value) {
					// Убираем все нецифровые символы
					let digits = value.replace(/\D/g, '');

					// Заменяем 8 на 7 в начале
					if (digits.startsWith('8')) {
						digits = '7' + digits.slice(1);
					}

					// Ограничиваем до 11 цифр
					digits = digits.slice(0, 11);

					// Форматируем только если есть цифры
					if (digits.length === 0) return '';

					let formatted = '+7';
					if (digits.length > 1) {
						formatted += ' (' + digits.slice(1, 4);
					}
					if (digits.length >= 4) {
						formatted += ') ' + digits.slice(4, 7);
					}
					if (digits.length >= 7) {
						formatted += '-' + digits.slice(7, 9);
					}
					if (digits.length >= 9) {
						formatted += '-' + digits.slice(9, 11);
					}

					return formatted;
				}

				// Обработчик ввода
				phoneField.addEventListener('input', function(e) {
					const cursorPosition = e.target.selectionStart;
					const oldValue = e.target.value;
					const newValue = formatPhone(e.target.value);

					e.target.value = newValue;

					// Восстанавливаем позицию курсора
					let newCursorPosition = cursorPosition;
					if (newValue.length < oldValue.length) {
						// Если текст стал короче (удаление), корректируем позицию
						newCursorPosition = Math.min(cursorPosition, newValue.length);
					} else if (newValue.length > oldValue.length) {
						// Если текст стал длиннее (добавление), корректируем позицию
						const addedChars = newValue.length - oldValue.length;
						newCursorPosition = cursorPosition + addedChars;
					}

					e.target.setSelectionRange(newCursorPosition, newCursorPosition);
				});

				// Обработчик клавиш для корректного удаления
				phoneField.addEventListener('keydown', function(e) {
					const cursorPosition = e.target.selectionStart;
					const value = e.target.value;

					// Если нажата Backspace и курсор находится после символа форматирования
					if (e.key === 'Backspace' && cursorPosition > 0) {
						const charBefore = value[cursorPosition - 1];
						// Если перед курсором символ форматирования, удаляем его и предыдущую цифру
						if (charBefore === ' ' || charBefore === '(' || charBefore === ')' || charBefore === '-') {
							e.preventDefault();
							// Удаляем символ форматирования и предыдущую цифру
							const newValue = value.slice(0, cursorPosition - 2) + value.slice(cursorPosition);
							e.target.value = formatPhone(newValue);
							// Устанавливаем курсор на правильную позицию
							const newCursorPosition = Math.max(0, cursorPosition - 2);
							e.target.setSelectionRange(newCursorPosition, newCursorPosition);
						}
					}

					// Если нажата Delete и курсор находится перед символом форматирования
					if (e.key === 'Delete' && cursorPosition < value.length) {
						const charAfter = value[cursorPosition];
						// Если после курсора символ форматирования, удаляем его и следующую цифру
						if (charAfter === ' ' || charAfter === '(' || charAfter === ')' || charAfter === '-') {
							e.preventDefault();
							// Удаляем символ форматирования и следующую цифру
							const newValue = value.slice(0, cursorPosition) + value.slice(cursorPosition + 2);
							e.target.value = formatPhone(newValue);
							// Курсор остается на том же месте
							e.target.setSelectionRange(cursorPosition, cursorPosition);
						}
					}
				});
			}

			// Функция для очистки ошибок поля
			function clearFieldError(field) {
				// Ищем контейнер .field-block для всех полей
				let fieldContainer = field.closest('.field-block');

				// Если не найден .field-block, ищем другие возможные контейнеры
				if (!fieldContainer) {
					fieldContainer = field.closest('.field') || field.closest('.shopping-form__field-cont') || field.closest('.agreement-cont');
				}

				// Специальная обработка для поля времени (скрытый input в кастомном селекте)
				if (!fieldContainer && field.name === 'shopping_time') {
					// Ищем кастомный селект времени и его контейнер
					const timeSelect = document.querySelector('[data-select="time"]');
					if (timeSelect) {
						fieldContainer = timeSelect.closest('.field-block') || timeSelect.closest('.field');
					}
				}

				// Специальная обработка для поля стилиста (скрытый input в кастомном селекте)
				if (!fieldContainer && field.name === 'shopping_stylist') {
					// Ищем кастомный селект стилиста и его контейнер
					const stylistSelect = document.querySelector('[data-select="stylist"]');
					if (stylistSelect) {
						fieldContainer = stylistSelect.closest('.field-block') || stylistSelect.closest('.field');
					}
				}

				// Если контейнер - это сам input, ищем его родительский контейнер
				if (fieldContainer === field) {
					fieldContainer = field.parentNode;
				}

				// Проверяем, что контейнер найден
				if (!fieldContainer) {
					console.error('Контейнер поля не найден для очистки ошибок:', field);
					return;
				}

				const existingError = fieldContainer.querySelector('div.field-error');
				if (existingError) {
					existingError.remove();
				}
				field.classList.remove('field-error');
				fieldContainer.classList.remove('field-error');

				// Сбрасываем флаг отправки при изменении полей
				isFormSubmitted = false;
			}

			// Убираем ошибки при вводе в текстовые поля
			const textFieldsToClearErrors = [
				'input[name="shopping_customer_name"]',
				'input[name="shopping_customer_lastname"]',
				'input[name="shopping_customer_phone"]'
			];

			textFieldsToClearErrors.forEach(selector => {
				const field = document.querySelector(selector);
				if (field) {
					field.addEventListener('input', function() {
						clearFieldError(this);
					});
				}
			});

			// Убираем ошибки при изменении селекта стилиста
			const stylistField = document.querySelector('input[name="shopping_stylist"]');
			if (stylistField) {
				stylistField.addEventListener('change', function() {
					clearFieldError(this);
					// Обновляем состояние поля времени при изменении стилиста
					if (typeof updateTimeFieldState === 'function') {
						updateTimeFieldState();
					}
				});
			}

			// Убираем ошибки при изменении селекта времени
			const timeField = document.querySelector('input[name="shopping_time"]');
			if (timeField) {
				timeField.addEventListener('change', function() {
					clearFieldError(this);
				});
			}

			// Убираем ошибки при изменении поля даты
			const dateField = document.querySelector('input[name="shopping_date"]');
			if (dateField) {
				dateField.addEventListener('change', function() {
					clearFieldError(this);
					// Обновляем состояние поля времени при изменении даты
					if (typeof updateTimeFieldState === 'function') {
						updateTimeFieldState();
					}
				});
			}

			// Убираем ошибки при изменении чекбокса согласия
			const agreementField = document.querySelector('input[name="shopping_agreement"]');
			if (agreementField) {
				agreementField.addEventListener('change', function() {
					clearFieldError(this);
				});
			}

			// Отключаем стандартную HTML валидацию
			bookingForm.setAttribute('novalidate', 'true');

			// Обработчик отправки формы
			bookingForm.addEventListener('submit', function(e) {
				e.preventDefault();

				// Проверяем, не была ли форма уже отправлена
				if (window.isFormSubmitted) {
					return;
				}

				// Валидируем форму
				const isValid = validateForm();

				if (isValid) {
					// Форма валидна, проверяем и инициализируем reCAPTCHA при необходимости
					let recaptchaContainer = document.getElementById('recaptcha-container');

					// Если контейнер не найден, пытаемся найти его в разных местах
					if (!recaptchaContainer) {
						// Ищем в форме
						recaptchaContainer = bookingForm.querySelector('#recaptcha-container');
					}
					if (!recaptchaContainer) {
						// Ищем в submit-cont
						const submitCont = bookingForm.querySelector('.submit-cont');
						if (submitCont) {
							recaptchaContainer = submitCont.querySelector('#recaptcha-container');
						}
					}
					if (!recaptchaContainer) {
						// Ищем во всем документе
						recaptchaContainer = document.querySelector('#recaptcha-container');
					}

					// Если контейнер все еще не найден, создаем его динамически
					if (!recaptchaContainer) {
						const submitCont = bookingForm.querySelector('.submit-cont');
						if (submitCont) {
							// Проверяем и создаем скрытые поля, если их нет
							if (!submitCont.querySelector('input[name="event_id"]')) {
								const eventIdInput = document.createElement('input');
								eventIdInput.type = 'hidden';
								eventIdInput.name = 'event_id';
								submitCont.insertBefore(eventIdInput, submitCont.firstChild);
							}
							if (!submitCont.querySelector('input[name="g_token"]')) {
								const gTokenInput = document.createElement('input');
								gTokenInput.type = 'hidden';
								gTokenInput.name = 'g_token';
								gTokenInput.id = 'g_token';
								gTokenInput.value = '';
								submitCont.insertBefore(gTokenInput, submitCont.firstChild);
							}

							// Создаем контейнер перед кнопкой submit
							recaptchaContainer = document.createElement('div');
							recaptchaContainer.id = 'recaptcha-container';

							// Устанавливаем sitekey из настроек WordPress
							let sitekey = null;
							if (typeof ajax_object !== 'undefined' && ajax_object.recaptcha_site_key) {
								sitekey = ajax_object.recaptcha_site_key;
							}

							if (!sitekey || sitekey.trim() === '') {
								console.error('reCAPTCHA sitekey не найден в настройках WordPress. Укажите ключ в настройках темы (publichnyj_klyuch).');
								// Не создаем контейнер без ключа
								return;
							}

							recaptchaContainer.setAttribute('data-sitekey', sitekey);

							const submitButton = submitCont.querySelector('button[type="submit"]');
							if (submitButton) {
								submitCont.insertBefore(recaptchaContainer, submitButton);
							} else {
								submitCont.insertBefore(recaptchaContainer, submitCont.firstChild);
							}
							console.log('Контейнер reCAPTCHA создан динамически');
						}
					}

					// Проверяем, загружен ли grecaptcha
					if (typeof grecaptcha === 'undefined') {
						alert('Пожалуйста, подождите, загружается проверка reCAPTCHA. Попробуйте еще раз через несколько секунд.');
						return;
					}

					// Если контейнер существует, но reCAPTCHA не инициализирована, пытаемся инициализировать
					if (recaptchaContainer) {
						if (window.recaptchaWidgetId === null) {
							const initSuccess = initRecaptcha();
							if (!initSuccess) {
								// Пробуем еще раз через небольшую задержку
								setTimeout(() => {
									if (initRecaptcha()) {
										recaptchaContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
										alert('Пожалуйста, пройдите проверку reCAPTCHA перед отправкой формы');
									} else {
										alert('Ошибка инициализации reCAPTCHA. Пожалуйста, обновите страницу.');
									}
								}, 300);
								return;
							}
						}
					} else {
						// Контейнер не найден и не может быть создан - это критическая ошибка
						console.error('Не удалось найти или создать контейнер reCAPTCHA');
						alert('Ошибка конфигурации формы. Пожалуйста, обновите страницу.');
						return;
					}

					// Проверяем наличие токена reCAPTCHA
					let token = null;
					if (window.recaptchaWidgetId !== null) {
						token = grecaptcha.getResponse(window.recaptchaWidgetId);
					}

					// Также проверяем сохраненный токен
					if (!token && window.recaptchaToken) {
						token = window.recaptchaToken;
					}

					if (!token || token.length === 0) {
						// Токена нет, значит пользователь еще не прошел проверку reCAPTCHA
						// Прокручиваем к reCAPTCHA
						if (recaptchaContainer) {
							recaptchaContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
							// Добавляем визуальное выделение
							recaptchaContainer.style.outline = '2px solid #ff0000';
							recaptchaContainer.style.transition = 'outline 0.3s ease';
							setTimeout(() => {
								recaptchaContainer.style.outline = '';
							}, 2000);
						}
						alert('Пожалуйста, пройдите проверку reCAPTCHA перед отправкой формы');
						return;
					}

					// Устанавливаем флаг отправки
					window.isFormSubmitted = true;

					// Показываем индикатор загрузки
					const submitButton = bookingForm.querySelector('button[type="submit"]');
					if (submitButton) {
						submitButton.textContent = 'Отправка...';
						submitButton.disabled = true;
					}

					// Собираем данные формы
					const formData = new FormData(bookingForm);

					// Форматируем телефон для API (формат: +(999) 999 99 99)
					const rawPhone = formData.get('shopping_customer_phone') || '';
					const formattedPhone = rawPhone.replace(/\D/g, ''); // Убираем все нецифровые символы
					let phoneForApi;
					if (formattedPhone.startsWith('7') && formattedPhone.length === 11) {
						// Формат: +7 (999) 999 99 99
						const code = formattedPhone.substring(1, 4);
						const part1 = formattedPhone.substring(4, 7);
						const part2 = formattedPhone.substring(7, 9);
						const part3 = formattedPhone.substring(9, 11);
						phoneForApi = `+7 (${code}) ${part1} ${part2} ${part3}`;
					} else if (formattedPhone.startsWith('7')) {
						phoneForApi = `+${formattedPhone}`;
					} else {
						phoneForApi = `+7${formattedPhone}`;
					}

					// Подготавливаем данные для API подтверждения телефона
					const apiData = {
						personal_data_agree: formData.get('shopping_agreement') ? true : false, // Согласие на обработку персональных данных
						email_subscribe_agree: false, // Подписка на email (по умолчанию false)
						phone: phoneForApi, // Номер телефона в формате +(999) 999 99 99
						g_token: token // Токен reCAPTCHA
					};

					// Отправляем данные в API подтверждения телефона
					fetch('https://krs.planeta-mall.ru/api/account/send-token', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify(apiData)
					})
					.then(response => {
						return response.json();
					})
					.then(data => {

						if (data.success) {
							// Сохраняем данные формы для последующего использования
							const eventIdInput = bookingForm.querySelector('input[name="event_id"]');
							const stylistIdInput = bookingForm.querySelector('input[name="shopping_stylist"]');
							const dateInput = bookingForm.querySelector('input[name="shopping_date"]');
							const timeInput = bookingForm.querySelector('input[name="shopping_time"]');

							// Получаем имя стилиста из window.stylistsData
							let stylistName = '';
							if (stylistIdInput && window.stylistsData && window.stylistsData.results && Array.isArray(window.stylistsData.results)) {
								const stylistId = stylistIdInput.value;
								const stylist = window.stylistsData.results.find(s => s.id == stylistId);
								if (stylist) {
									// Пробуем разные варианты полей для имени
									stylistName = stylist.title || stylist.name || `${stylist.firstname || ''} ${stylist.lastname || ''}`.trim();
								}
							}

							// Сохраняем данные в window.bookingData
							window.bookingData = {
								event_id: eventIdInput ? eventIdInput.value : null,
								stylist_id: stylistIdInput ? stylistIdInput.value : null,
								stylist_name: stylistName,
								date: dateInput ? dateInput.value : null,
								time: timeInput ? timeInput.value : null
							};

							// Заполняем скрытые поля в форме СМС
							const smsHiddenPhone = document.getElementById('sms-hidden-phone');
							const smsHiddenLastname = document.getElementById('sms-hidden-lastname');
							const smsHiddenFirstname = document.getElementById('sms-hidden-firstname');
							const smsHiddenPersonalDataAgree = document.getElementById('sms-hidden-personal-data-agree');
							const smsHiddenEmailSubscribeAgree = document.getElementById('sms-hidden-email-subscribe-agree');

							if (smsHiddenPhone) smsHiddenPhone.value = phoneForApi;
							if (smsHiddenLastname) smsHiddenLastname.value = formData.get('shopping_customer_lastname') || '';
							if (smsHiddenFirstname) smsHiddenFirstname.value = formData.get('shopping_customer_name') || '';
							if (smsHiddenPersonalDataAgree) smsHiddenPersonalDataAgree.value = formData.get('shopping_agreement') ? 'true' : 'false';
							if (smsHiddenEmailSubscribeAgree) smsHiddenEmailSubscribeAgree.value = 'false';

							// Очищаем форму бронирования
							bookingForm.reset();

							// Сбрасываем reCAPTCHA
							if (window.recaptchaWidgetId !== null && typeof grecaptcha !== 'undefined') {
								grecaptcha.reset(window.recaptchaWidgetId);
							}
							window.recaptchaToken = null;

							// Сбрасываем флаг отправки
							window.isFormSubmitted = false;

							// Восстанавливаем кнопку
							if (submitButton) {
								submitButton.textContent = 'Отправить';
								submitButton.disabled = false;
							}

							// Открываем попап СМС
							if (typeof Fancybox !== 'undefined') {
								const smsPopup = document.getElementById('sms-popup');
								if (smsPopup) {
									Fancybox.show([{ src: "#sms-popup", type: "inline"}], {backdropClick: false, compact: false });

									// Запускаем таймер через небольшую задержку
									setTimeout(() => {
										if (typeof window.startSmsResendTimer === 'function') {
											window.startSmsResendTimer();
										}
									}, 300);
								}
							}
						} else {
							// Ошибка при отправке
							let errorMessage = 'Произошла ошибка при отправке кода. Попробуйте еще раз.';
							if (data.error) {
								errorMessage = data.error;
							}
							alert(errorMessage);

							// Восстанавливаем кнопку
							if (submitButton) {
								submitButton.textContent = 'Отправить';
								submitButton.disabled = false;
							}

							// Сбрасываем флаг отправки
							window.isFormSubmitted = false;

							// Сбрасываем reCAPTCHA
							if (window.recaptchaWidgetId !== null && typeof grecaptcha !== 'undefined') {
								grecaptcha.reset(window.recaptchaWidgetId);
							}
							window.recaptchaToken = null;
						}
					})
					.catch(error => {
						console.error('Ошибка отправки формы:', error);
						alert('Произошла ошибка при отправке формы. Попробуйте еще раз.');

						// Восстанавливаем кнопку
						if (submitButton) {
							submitButton.textContent = 'Отправить';
							submitButton.disabled = false;
						}

						// Сбрасываем флаг отправки
						window.isFormSubmitted = false;

						// Сбрасываем reCAPTCHA
						if (window.recaptchaWidgetId !== null && typeof grecaptcha !== 'undefined') {
							grecaptcha.reset(window.recaptchaWidgetId);
						}
						window.recaptchaToken = null;
					});

				} else {
					// Форма невалидна

					// Прокручиваем к первой ошибке
					const firstError = this.querySelector('.field-error');
					if (firstError) {
						firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
					}
				}
			});
		}

		// Переменные для таймера (глобальные, чтобы функция могла к ним обращаться)
		window.smsResendTimerInterval = null;
		window.smsResendSeconds = 60; // 60 секунд таймер

		// Функция для запуска таймера обратного отсчета
		// Делаем функцию доступной глобально для вызова из других мест
		// Определяем функцию ВСЕГДА, независимо от наличия формы на странице
		window.startSmsResendTimer = function() {
			console.log('Вызов startSmsResendTimer');

			// Очищаем предыдущий таймер, если он был
			if (window.smsResendTimerInterval) {
				clearInterval(window.smsResendTimerInterval);
				window.smsResendTimerInterval = null;
			}

			// Ищем элементы внутри попапа СМС
			const smsPopup = document.getElementById('sms-popup');
			if (!smsPopup) {
				console.error('Попап СМС не найден');
				return;
			}

			const timerElement = smsPopup.querySelector('.code-timer');
			const resendButton = smsPopup.querySelector('.btn-resend-code');
			const resendButtonContainer = smsPopup.querySelector('.form-status-resend .button');
			const resendText = smsPopup.querySelector('.form-status-resend .text');

			if (!timerElement) {
				console.error('Элемент таймера не найден');
				return;
			}

			// Скрываем кнопку и показываем текст с таймером
			if (resendButtonContainer) {
				resendButtonContainer.style.display = 'none';
			}
			if (resendText) {
				resendText.style.display = 'block';
			}

			// Сбрасываем счетчик
			window.smsResendSeconds = 60;

			// Первоначальное обновление
			const initialMinutes = Math.floor(window.smsResendSeconds / 60);
			const initialSeconds = window.smsResendSeconds % 60;
			timerElement.textContent = `${String(initialMinutes).padStart(2, '0')}:${String(initialSeconds).padStart(2, '0')}`;

			// Обновляем таймер каждую секунду
			window.smsResendTimerInterval = setInterval(() => {
				window.smsResendSeconds--;

				if (window.smsResendSeconds <= 0) {
					// Таймер истек, показываем кнопку
					clearInterval(window.smsResendTimerInterval);
					window.smsResendTimerInterval = null;

					// Обновляем ссылки на элементы (на случай, если DOM изменился)
					const currentSmsPopup = document.getElementById('sms-popup');
					if (currentSmsPopup) {
						const currentResendButtonContainer = currentSmsPopup.querySelector('.form-status-resend .button');
						const currentResendText = currentSmsPopup.querySelector('.form-status-resend .text');

						if (currentResendButtonContainer) {
							currentResendButtonContainer.style.display = 'block';
							console.log('Кнопка показана');
						}
						if (currentResendText) {
							currentResendText.style.display = 'none';
						}
					}
				} else {
					// Обновляем отображение таймера
					const currentSmsPopup = document.getElementById('sms-popup');
					if (currentSmsPopup) {
						const currentTimerElement = currentSmsPopup.querySelector('.code-timer');
						if (currentTimerElement) {
							const minutes = Math.floor(window.smsResendSeconds / 60);
							const seconds = window.smsResendSeconds % 60;
							const timeString = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
							currentTimerElement.textContent = timeString;
						} else {
							console.warn('Элемент таймера не найден при обновлении');
						}
					}
				}
			}, 1000);
		};

		// Обработчик формы подтверждения СМС
		const smsForm = document.querySelector('.form-sms');
		const smsPopup = document.getElementById('sms-popup'); // Определяем smsPopup заранее, чтобы использовать на строке 1965

		if (smsForm) {

			// Функция для повторной отправки кода
			function resendSmsCode() {
				const smsForm = document.querySelector('.form-sms');
				if (!smsForm) return;

				// Получаем данные из скрытых полей формы СМС
				const phone = document.getElementById('sms-hidden-phone')?.value || '';
				const personalDataAgree = document.getElementById('sms-hidden-personal-data-agree')?.value === 'true';
				const emailSubscribeAgree = document.getElementById('sms-hidden-email-subscribe-agree')?.value === 'true';

				if (!phone) {
					alert('Ошибка: не найден номер телефона');
					return;
				}

				// Форматируем телефон для API (формат: +(999) 999 99 99)
				const formattedPhone = phone.replace(/\D/g, ''); // Убираем все нецифровые символы
				let phoneForApi;
				if (formattedPhone.startsWith('7') && formattedPhone.length === 11) {
					// Формат: +7 (999) 999 99 99
					const code = formattedPhone.substring(1, 4);
					const part1 = formattedPhone.substring(4, 7);
					const part2 = formattedPhone.substring(7, 9);
					const part3 = formattedPhone.substring(9, 11);
					phoneForApi = `+7 (${code}) ${part1} ${part2} ${part3}`;
				} else if (formattedPhone.startsWith('7')) {
					phoneForApi = `+${formattedPhone}`;
				} else {
					phoneForApi = `+7${formattedPhone}`;
				}

				// Проверяем и инициализируем reCAPTCHA для повторной отправки
				let recaptchaContainer = document.getElementById('sms-recaptcha-container');
				let smsRecaptchaWidgetId = null;

				// Проверяем, загружен ли grecaptcha
				if (typeof grecaptcha === 'undefined') {
					alert('Пожалуйста, подождите, загружается проверка reCAPTCHA. Попробуйте еще раз через несколько секунд.');
					return;
				}

				// Инициализируем reCAPTCHA, если она еще не инициализирована
				if (recaptchaContainer) {
					// Проверяем, не инициализирована ли уже reCAPTCHA
					const existingWidgetId = recaptchaContainer.getAttribute('data-widget-id');
					if (existingWidgetId) {
						smsRecaptchaWidgetId = parseInt(existingWidgetId);
					} else {
						// Получаем sitekey
						let sitekey = recaptchaContainer.getAttribute('data-sitekey');
						if (!sitekey && typeof ajax_object !== 'undefined' && ajax_object.recaptcha_site_key) {
							sitekey = ajax_object.recaptcha_site_key;
						}

						if (!sitekey || sitekey.trim() === '') {
							alert('Ошибка: не найден ключ reCAPTCHA');
							return;
						}

						// Инициализируем reCAPTCHA
						try {
							smsRecaptchaWidgetId = grecaptcha.render('sms-recaptcha-container', {
								'sitekey': sitekey,
								'callback': function(token) {
									// Токен получен, отправляем запрос
									sendResendRequest(token, phoneForApi, personalDataAgree, emailSubscribeAgree, smsRecaptchaWidgetId);
								},
								'expired-callback': function() {
									alert('Время проверки reCAPTCHA истекло. Пожалуйста, пройдите проверку еще раз.');
									const resendButton = document.querySelector('.btn-resend-code');
									if (resendButton) {
										resendButton.disabled = false;
										resendButton.textContent = 'Запросить новый код';
									}
								}
							});
							recaptchaContainer.setAttribute('data-widget-id', smsRecaptchaWidgetId);
						} catch (error) {
							console.error('Ошибка инициализации reCAPTCHA:', error);
							alert('Ошибка инициализации reCAPTCHA. Попробуйте еще раз.');
							return;
						}
					}

					// Проверяем наличие токена
					const token = grecaptcha.getResponse(smsRecaptchaWidgetId);
					if (!token || token.length === 0) {
						// Токена нет, значит пользователь еще не прошел проверку reCAPTCHA
						alert('Пожалуйста, пройдите проверку reCAPTCHA перед запросом нового кода');
						return;
					}

					// Токен есть, отправляем запрос
					sendResendRequest(token, phoneForApi, personalDataAgree, emailSubscribeAgree, smsRecaptchaWidgetId);
				} else {
					// Контейнер не найден, отправляем без капчи (fallback)
					sendResendRequest('', phoneForApi, personalDataAgree, emailSubscribeAgree, null);
				}

				// Функция для отправки запроса на повторную отправку кода
				function sendResendRequest(gToken, phoneForApi, personalDataAgree, emailSubscribeAgree, smsRecaptchaWidgetId) {
					// Подготавливаем данные для API
					const apiData = {
						personal_data_agree: personalDataAgree,
						email_subscribe_agree: emailSubscribeAgree,
						phone: phoneForApi,
						g_token: gToken
					};

					console.log('Повторная отправка кода СМС:', {
						...apiData,
						g_token: gToken ? gToken.substring(0, 50) + '...' : 'пустой'
					});

					// Показываем индикатор загрузки
					const resendButton = document.querySelector('.btn-resend-code');
					if (resendButton) {
						resendButton.disabled = true;
						resendButton.textContent = 'Отправка...';
					}

					// Отправляем запрос
					fetch('https://krs.planeta-mall.ru/api/account/send-token', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
						},
						body: JSON.stringify(apiData)
					})
						.then(response => {
							console.log('API Response status (resend):', response.status);
							return response.json();
						})
						.then(data => {
							console.log('API Response data (resend):', data);
							if (data.success) {
								// Успешно отправлено, перезапускаем таймер
								if (typeof window.startSmsResendTimer === 'function') {
									window.startSmsResendTimer();
								}

								// Очищаем поле кода
								const codeInput = smsForm.querySelector('#smscode');
								if (codeInput) {
									codeInput.value = '';
								}

								// Очищаем ошибки
								clearSmsCodeError();

								// Сбрасываем reCAPTCHA
								if (smsRecaptchaWidgetId !== null && typeof grecaptcha !== 'undefined') {
									grecaptcha.reset(smsRecaptchaWidgetId);
								}
							} else {
								// Ошибка при отправке
								let errorMessage = 'Произошла ошибка при отправке кода.';
								if (data.error) {
									errorMessage = data.error;
								}
								alert(errorMessage);

								// Сбрасываем reCAPTCHA при ошибке
								if (smsRecaptchaWidgetId !== null && typeof grecaptcha !== 'undefined') {
									grecaptcha.reset(smsRecaptchaWidgetId);
								}
							}
						})
						.catch(error => {
							console.error('Ошибка повторной отправки кода СМС:', error);
							alert('Произошла ошибка при отправке кода. Попробуйте еще раз.');

							// Сбрасываем reCAPTCHA при ошибке
							if (smsRecaptchaWidgetId !== null && typeof grecaptcha !== 'undefined') {
								grecaptcha.reset(smsRecaptchaWidgetId);
							}
						})
						.finally(() => {
							// Восстанавливаем кнопку
							const resendButton = document.querySelector('.btn-resend-code');
							if (resendButton) {
								resendButton.disabled = false;
								resendButton.textContent = 'Запросить новый код';
							}
						});
				}
			}

			// Обработчик кнопки повторной отправки
			const resendButton = document.querySelector('.btn-resend-code');
			if (resendButton) {
				resendButton.addEventListener('click', function(e) {
					e.preventDefault();
					e.stopPropagation(); // Блокируем всплытие события
					resendSmsCode();
				});
			}

			// Блокируем клики на все кнопки внутри попапа СМС
			if (smsPopup) {
				const buttons = smsPopup.querySelectorAll('button, .btn');
				buttons.forEach(button => {
					button.addEventListener('click', function(e) {
						e.stopPropagation(); // Блокируем всплытие, чтобы не открывались другие попапы
					});
				});
			}

			// Обработчики событий Fancybox для попапа СМС
			if (typeof Fancybox !== 'undefined') {
				// Запускаем таймер при открытии попапа СМС через несколько способов

				// Способ 1: Событие fancybox:reveal
				document.addEventListener('fancybox:reveal', function(e) {
					// Проверяем, что открывается именно попап СМС
					const src = e.detail?.src || e.detail?.target?.src || '';
					if (src && (src.includes('sms-popup') || src === '#sms-popup')) {
						console.log('Попап СМС открыт через fancybox:reveal, запускаем таймер');
						setTimeout(() => {
							if (typeof window.startSmsResendTimer === 'function') {
								window.startSmsResendTimer();
							}
						}, 200);
					}
				});

				// Способ 2: Глобальный обработчик через Fancybox API (только для data-fancybox, не для #sms-popup)
				// Убираем #sms-popup из bind, так как он уже открыт через Fancybox.show

				// Останавливаем таймер при закрытии попапа
				document.addEventListener('fancybox:close', function(e) {
					// Проверяем, что закрывается именно попап СМС
					if (e.detail && e.detail.src && (e.detail.src.includes('sms-popup') || e.detail.src === '#sms-popup')) {
						console.log('Попап СМС закрыт, останавливаем таймер');
						if (window.smsResendTimerInterval) {
							clearInterval(window.smsResendTimerInterval);
							window.smsResendTimerInterval = null;
						}
					}
				});
			}

			// Функция для отображения ошибки у поля кода СМС
			function showSmsCodeError(message) {
				const codeInput = smsForm.querySelector('#smscode');
				if (!codeInput) return;

				// Находим контейнер поля
				const fieldContainer = codeInput.closest('.form-field') || codeInput.parentElement;

				// Очищаем предыдущие ошибки
				const existingError = fieldContainer.querySelector('div.field-error');
				if (existingError) {
					existingError.remove();
				}
				codeInput.classList.remove('field-error');
				fieldContainer.classList.remove('field-error');

				// Добавляем класс ошибки
				codeInput.classList.add('field-error');
				fieldContainer.classList.add('field-error');

				// Создаем элемент ошибки
				const errorElement = document.createElement('div');
				errorElement.className = 'field-error field-error-text';
				errorElement.textContent = message;

				// Добавляем ошибку в конец контейнера поля
				fieldContainer.appendChild(errorElement);
			}

			// Функция для очистки ошибки у поля кода СМС
			function clearSmsCodeError() {
				const codeInput = smsForm.querySelector('#smscode');
				if (!codeInput) return;

				const fieldContainer = codeInput.closest('.form-field') || codeInput.parentElement;
				const existingError = fieldContainer.querySelector('div.field-error');
				if (existingError) {
					existingError.remove();
				}
				codeInput.classList.remove('field-error');
				fieldContainer.classList.remove('field-error');
			}

			// Очищаем ошибку при вводе в поле кода
			const codeInput = smsForm.querySelector('#smscode');
			if (codeInput) {
				codeInput.addEventListener('input', function() {
					clearSmsCodeError();
				});
			}

			// Блокируем всплытие событий для всех элементов внутри попапа СМС, чтобы предотвратить открытие других попапов
			if (smsPopup) {
				// Добавляем атрибут, чтобы Fancybox игнорировал этот попап при автоматической обработке
				smsPopup.setAttribute('data-fancybox-ignore', 'true');

				// Блокируем все клики внутри попапа на уровне capture phase
				smsPopup.addEventListener('click', function(e) {
					const target = e.target;

					// Разрешаем клики только на интерактивные элементы формы
					const isAllowedElement = target.tagName === 'BUTTON' ||
					                       target.tagName === 'INPUT' ||
					                       target.tagName === 'TEXTAREA' ||
					                       target.closest('button') ||
					                       target.closest('input[type="text"]') ||
					                       target.closest('form') ||
					                       target.closest('#sms-recaptcha-container') ||
					                       target.closest('.form-field') ||
					                       target.closest('.form-status-resend') ||
					                       target.closest('.form-status-content');

					// Если это не разрешенный элемент, блокируем всплытие
					if (!isAllowedElement) {
						e.stopPropagation();
						e.stopImmediatePropagation();
						e.preventDefault(); // Также предотвращаем действие по умолчанию
					}
				}, true); // Используем capture phase

				// Дополнительная блокировка на уровне document для предотвращения обработки Fancybox
				const smsPopupClickHandler = function(e) {
					// Проверяем, что клик произошел внутри попапа СМС
					if (smsPopup.contains(e.target)) {
						const target = e.target;
						// Разрешаем только клики на элементы формы
						const isFormElement = target.closest('.form-sms') ||
						                     target.closest('button') ||
						                     target.closest('input') ||
						                     target.closest('#sms-recaptcha-container');

						// Если это не элемент формы, блокируем обработку
						if (!isFormElement) {
							e.stopPropagation();
							e.stopImmediatePropagation();
							e.preventDefault(); // Также предотвращаем действие по умолчанию
						}
					}
				};

				// Добавляем обработчик на capture phase, чтобы перехватить до Fancybox
				document.addEventListener('click', smsPopupClickHandler, true);

				// Сохраняем ссылку на обработчик для возможного удаления
				smsPopup._smsClickHandler = smsPopupClickHandler;
			}

			smsForm.addEventListener('submit', function(e) {
				e.preventDefault();
				e.stopPropagation(); // Блокируем всплытие события

				// Очищаем предыдущие ошибки
				clearSmsCodeError();

				// Получаем данные формы
				const formData = new FormData(smsForm);
				const code = formData.get('code') || '';
				const phone = formData.get('phone') || '';
				const lastname = formData.get('lastname') || '';
				const firstname = formData.get('firstname') || '';
				const personalDataAgree = formData.get('personal_data_agree') === 'true';
				const emailSubscribeAgree = formData.get('email_subscribe_agree') === 'true';

				// Валидация кода
				if (!code || code.trim() === '') {
					showSmsCodeError('Пожалуйста, введите код из СМС');
					return;
				}

				// Показываем индикатор загрузки
				const submitButton = smsForm.querySelector('button[type="submit"]');
				if (submitButton) {
					submitButton.textContent = 'Отправка...';
					submitButton.disabled = true;
				}

				// Форматируем телефон для API (формат: +(999) 999 99 99)
				const formattedPhone = phone.replace(/\D/g, ''); // Убираем все нецифровые символы
				let phoneForApi;
				if (formattedPhone.startsWith('7') && formattedPhone.length === 11) {
					// Формат: +7 (999) 999 99 99
					const code = formattedPhone.substring(1, 4);
					const part1 = formattedPhone.substring(4, 7);
					const part2 = formattedPhone.substring(7, 9);
					const part3 = formattedPhone.substring(9, 11);
					phoneForApi = `+7 (${code}) ${part1} ${part2} ${part3}`;
				} else if (formattedPhone.startsWith('7')) {
					phoneForApi = `+${formattedPhone}`;
				} else {
					phoneForApi = `+7${formattedPhone}`;
				}

				// Подготавливаем данные для API проверки токена
				const apiData = {
					token: parseInt(code.trim()), // Код из СМС
					personal_data_agree: personalDataAgree, // Согласие на обработку персональных данных
					email_subscribe_agree: emailSubscribeAgree, // Подписка на email
					phone: phoneForApi, // Номер телефона в формате +(999) 999 99 99
					lastname: lastname, // Фамилия пользователя
					firstname: firstname // Имя пользователя
				};

				console.log('Данные для отправки в API проверки токена:', apiData);

				// Отправляем данные в API проверки токена
				// Создаем AbortController для таймаута
				const controller = new AbortController();
				const timeoutId = setTimeout(() => controller.abort(), 30000); // 30 секунд таймаут

				fetch('https://krs.planeta-mall.ru/api/account/check-token', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
					},
					body: JSON.stringify(apiData),
					signal: controller.signal
				})
				.then(response => {
					clearTimeout(timeoutId);
					console.log('API Response status:', response.status);
					const status = response.status;

					// Обрабатываем серверные ошибки (500, 502, 503, 504)
					if (status === 504) {
						// 504 Gateway Timeout - сервер не отвечает
						return { status, data: { success: false, error: 'Сервер не отвечает. Пожалуйста, попробуйте еще раз через несколько секунд.' } };
					} else if (status === 502 || status === 503) {
						// 502 Bad Gateway, 503 Service Unavailable
						return { status, data: { success: false, error: 'Сервер временно недоступен. Пожалуйста, попробуйте еще раз.' } };
					} else if (status >= 500) {
						// Другие серверные ошибки
						return { status, data: { success: false, error: 'Ошибка сервера. Пожалуйста, попробуйте еще раз.' } };
					}

					// Для остальных статусов пытаемся распарсить JSON
					return response.json().then(data => {
						return { status, data };
					}).catch(error => {
						// Если не удалось распарсить JSON (например, при 504 может не быть JSON тела)
						console.error('Ошибка парсинга JSON:', error);
						if (status === 504) {
							return { status, data: { success: false, error: 'Сервер не отвечает. Пожалуйста, попробуйте еще раз через несколько секунд.' } };
						}
						return { status, data: { success: false, error: 'Ошибка обработки ответа сервера' } };
					});
				})
				.then(result => {
					const { status, data } = result;
					console.log('API Response data:', data);
					// Проверяем успешность: success должен быть true ИЛИ status должен быть 200 (но не 400)
					if (data.success === true && status !== 400) {
						// Получаем данные пользователя из ответа
						const userId = data.results?.id;
						const apiToken = data.results?.api_token;

						if (!userId || !apiToken) {
							console.error('Ошибка: не получены user_id или api_token из ответа');
							alert('Ошибка обработки ответа сервера. Попробуйте еще раз.');
							return;
						}

						// Получаем event_id из сохраненных данных
						const eventId = window.bookingData?.event_id;

						if (!eventId) {
							console.error('Ошибка: не найден event_id в сохраненных данных');
							alert('Ошибка: не выбрана дата и время записи. Пожалуйста, заполните форму заново.');
							return;
						}

						// Отправляем запрос на сохранение записи к стилисту
						fetch('https://ufa.planeta-mall.ru/api/account/save/stylist', {
							method: 'POST',
							headers: {
								'Content-Type': 'application/json',
								'Authorization': `Bearer ${apiToken}`
							},
							body: JSON.stringify({
								event_id: parseInt(eventId),
								user_id: parseInt(userId)
							})
						})
						.then(response => {
							console.log('Save stylist response status:', response.status);
							if (!response.ok) {
								return response.json().then(errData => {
									throw new Error(errData.error || 'Ошибка сохранения записи');
								});
							}
							return response.json();
						})
						.then(saveData => {
							console.log('Save stylist response data:', saveData);

							// Получаем данные для заполнения попапа успеха из сохраненных данных
							const bookingData = window.bookingData || {};
							let dateValue = '';
							let timeValue = bookingData.time || '';
							let stylistName = bookingData.stylist_name || '';

							// Форматируем дату для отображения
							if (bookingData.date) {
								let date;
								if (bookingData.date.includes('.')) {
									// Формат DD.MM.YYYY от Air Datepicker
									const [day, month, year] = bookingData.date.split('.');
									date = new Date(year, month - 1, day);
								} else {
									// Формат YYYY-MM-DD от HTML5
									date = new Date(bookingData.date + 'T00:00:00');
								}

								// Форматируем дату для отображения
								const day = String(date.getDate()).padStart(2, '0');
								const month = String(date.getMonth() + 1).padStart(2, '0');
								const year = date.getFullYear();
								dateValue = `${day}.${month}.${year}`;
							}

							// Закрываем попап СМС перед показом success-popup
							if (typeof Fancybox !== 'undefined') {
								Fancybox.close();
							}

							// Очищаем форму СМС
							const codeInput = smsForm.querySelector('#smscode');
							if (codeInput) {
								codeInput.value = '';
							}

							// Останавливаем таймер
							if (window.smsResendTimerInterval) {
								clearInterval(window.smsResendTimerInterval);
								window.smsResendTimerInterval = null;
							}

							// Показываем попап успешной отправки после небольшой задержки
							setTimeout(() => {
								// Убеждаемся, что попап СМС закрыт
								if (typeof Fancybox !== 'undefined') {
									Fancybox.close();
								}

								// Небольшая дополнительная задержка
								setTimeout(() => {
									const successPopup = document.querySelector('#sms-popup-success');
									if (successPopup) {
										// Заполняем данные в попапе
										const dateValueElement = successPopup.querySelector('.date_value');
										const timeValueElement = successPopup.querySelector('.time_value');
										const stylistValueElement = successPopup.querySelector('.stylist_value');

										if (dateValueElement) dateValueElement.textContent = dateValue;
										if (timeValueElement) timeValueElement.textContent = timeValue;
										if (stylistValueElement) stylistValueElement.textContent = stylistName;

										// Показываем попап
										if (typeof Fancybox !== 'undefined') {
											Fancybox.show([{ src: "#sms-popup-success", type: "inline"}], {backdropClick: false, compact: false });
										}
									} else {
										alert('Ваша заявка принята!');
									}
								}, 100);
							}, 300);
						})
						.catch(error => {
							console.error('Ошибка сохранения записи к стилисту:', error);
							alert('Ошибка сохранения записи: ' + error.message + '. Попробуйте еще раз.');
						});
					} else {
						// Обрабатываем ошибки - не закрываем попап, показываем ошибку у поля
						let errorMessage = 'Неверный код. Попробуйте еще раз.';
						if (data.error) {
							// Если API вернул конкретное сообщение об ошибке, используем его
							if (data.error.includes('неверен') || data.error.includes('неверный')) {
								errorMessage = 'Неверный код. Попробуйте еще раз.';
							} else {
								errorMessage = data.error;
							}
						} else if (data.data) {
							errorMessage = data.data;
						}

						// Показываем ошибку у поля кода
						showSmsCodeError(errorMessage);

						// Прокручиваем к полю с ошибкой
						const codeInput = smsForm.querySelector('#smscode');
						if (codeInput) {
							codeInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
							codeInput.focus();
						}
					}
				})
				.catch(error => {
					clearTimeout(timeoutId);
					console.error('Ошибка отправки формы СМС:', error);

					// Определяем тип ошибки
					let errorMessage = 'Произошла ошибка при отправке кода. Попробуйте еще раз.';

					if (error.name === 'AbortError') {
						// Таймаут запроса
						errorMessage = 'Превышено время ожидания ответа сервера. Пожалуйста, попробуйте еще раз.';
					} else if (error.message && error.message.includes('504')) {
						errorMessage = 'Сервер не отвечает. Пожалуйста, попробуйте еще раз через несколько секунд.';
					} else if (error.message && (error.message.includes('502') || error.message.includes('503'))) {
						errorMessage = 'Сервер временно недоступен. Пожалуйста, попробуйте еще раз.';
					}

					// Показываем ошибку у поля, не закрываем попап
					showSmsCodeError(errorMessage);

					// Прокручиваем к полю с ошибкой
					const codeInput = smsForm.querySelector('#smscode');
					if (codeInput) {
						codeInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
						codeInput.focus();
					}
				})
				.finally(() => {
					// Восстанавливаем кнопку
					if (submitButton) {
						submitButton.textContent = 'Продолжить';
						submitButton.disabled = false;
					}
				});
			});
		}

		// Анимация логотипа в футере
		if (isExist('.footer__logo')) {
			const footerLogos = document.querySelectorAll('.footer__logo');

			// Функция для проверки видимости элемента
			function isElementInViewport(el) {
				const rect = el.getBoundingClientRect();
				return (
					rect.top >= 0 &&
					rect.left >= 0 &&
					rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
					rect.right <= (window.innerWidth || document.documentElement.clientWidth)
				);
			}

			// Функция для запуска анимации
			function animateFooterLogos() {
				footerLogos.forEach(logo => {
					if (isElementInViewport(logo) && !logo.classList.contains('animate')) {
						logo.classList.add('animate');
					}
				});
			}

			// Запускаем анимацию при загрузке страницы
			animateFooterLogos();

			// Запускаем анимацию при прокрутке
			window.addEventListener('scroll', animateFooterLogos);

			// Запускаем анимацию при изменении размера окна
			window.addEventListener('resize', animateFooterLogos);
		}
	});
})( jQuery );